import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";
import range from "lodash/range";
import * as React from "react";
import styled, { css } from "styled-components";

export const ROWS_PER_BATCH = 2;

interface IProps {
  itemsPerRowResponsive: ResponsiveValues<number>;
}

export const SingleProductRowPlaceholder: React.FC<IProps> = ({
  itemsPerRowResponsive,
}) => {
  return (
    <React.Fragment>
      {range(ROWS_PER_BATCH).map((value) => (
        <SingleProductRowPlaceholderWrapper
          $columns={itemsPerRowResponsive}
          key={value}
          data-test-id={`single-row-placeholder-${value}`}
        />
      ))}
    </React.Fragment>
  );
};

const SingleProductRowPlaceholderWrapper = styled.div<{
  $columns: ResponsiveValues<number>;
}>`
  max-width: 100%;
  width: 100%;

  ${responsiveMediaQueries.mobile} {
    height: 340px;
    grid-column: ${({ $columns }) => css`1/${$columns.mobileAndAbove + 1}`};
  }

  ${responsiveMediaQueries.tablet} {
    height: 375px;
    grid-column: ${({ $columns }) =>
      css`1/${($columns.tabletAndAbove ?? 2) + 1}`};
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    height: 440px;
    grid-column: ${({ $columns }) =>
      css`1/${($columns.desktopAndAbove ?? 5) + 1}`};
  }
`;
